import React from 'react';
import styled from 'styled-components';
import { Scissors, Sparkles, Star } from 'lucide-react';

// Styled Components
const SectionWrapper = styled.section`
  padding: 5rem 0;
  background: #f9fafb;
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }

  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  animation: fadeIn 0.8s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.25rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 1rem;

  @media (min-width: 640px) {
    font-size: 3rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.25rem;
  color: #4b5563;
  line-height: 1.6;
`;

const ServiceGrid = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #f3f4f6;
  animation: fadeInUp 0.6s ease-out;
  animation-delay: ${props => props.$delay || '0s'};
  animation-fill-mode: backwards;

  &:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    transform: translateY(-8px);
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ServiceIcon = styled.div`
  background: linear-gradient(135deg, #f3e8ff 0%, #fce7f3 100%);
  width: 80px;
  height: 80px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease;

  svg {
    width: 48px;
    height: 48px;
    color: #9333ea;
  }

  ${ServiceCard}:hover & {
    transform: scale(1.1) rotate(5deg);
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.75rem;
`;

const ServiceDescription = styled.p`
  color: #4b5563;
  margin-bottom: 1rem;
  line-height: 1.75;
`;

const ServicePrice = styled.p`
  color: #9333ea;
  font-weight: bold;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:before {
    content: '💎';
    font-size: 1rem;
  }
`;

const ServiceBadge = styled.span`
  display: inline-block;
  background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

// Component
const ServicesSection = () => {
  const services = [
    {
      icon: <Scissors />,
      title: "Hair Styling",
      description: "Cắt, nhuộm, uốn tóc chuyên nghiệp với stylist giàu kinh nghiệm",
      price: "Từ 150.000đ",
      badge: "Phổ biến",
      delay: "0.1s"
    },
    {
      icon: <Sparkles />,
      title: "Nail Art",
      description: "Làm móng nghệ thuật, sơn gel, nail extension cao cấp",
      price: "Từ 100.000đ",
      badge: "Best Seller",
      delay: "0.2s"
    },
    {
      icon: <Star />,
      title: "Spa & Treatment",
      description: "Chăm sóc tóc, dưỡng móng và massage thư giãn",
      price: "Từ 200.000đ",
      badge: "Premium",
      delay: "0.3s"
    }
  ];

  return (
    <SectionWrapper id="dịch vụ">
      <Container>
        <SectionHeader>
          <SectionTitle>Dịch Vụ Của Chúng Tôi</SectionTitle>
          <SectionSubtitle>
            Đa dạng dịch vụ chăm sóc sắc đẹp chuyên nghiệp
          </SectionSubtitle>
        </SectionHeader>

        <ServiceGrid>
          {services.map((service, index) => (
            <ServiceCard key={index} $delay={service.delay}>
              <ServiceBadge>{service.badge}</ServiceBadge>

              <ServiceIcon>
                {service.icon}
              </ServiceIcon>

              <ServiceTitle>{service.title}</ServiceTitle>

              <ServiceDescription>
                {service.description}
              </ServiceDescription>

              <ServicePrice>{service.price}</ServicePrice>
            </ServiceCard>
          ))}
        </ServiceGrid>
      </Container>
    </SectionWrapper>
  );
};

export default ServicesSection;